import React from 'react';
import styled from 'styled-components';


const SearchIcon = () => {
  return (
      <>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
              <g id="Search" transform="translate(-3 -3)">
                  <path id="Path_9364" d="M10.111,17.222a7.111,7.111,0,1,1,7.111-7.111A7.111,7.111,0,0,1,10.111,17.222Zm0-12.445a5.333,5.333,0,1,0,5.333,5.333,5.333,5.333,0,0,0-5.333-5.333Z" fill="#fff"/>
                  <path id="Path_9365" d="M19.444,20.333a.889.889,0,0,1-.628-.26L15.26,16.517a.889.889,0,1,1,1.257-1.257l3.555,3.556a.889.889,0,0,1-.628,1.517Z" transform="translate(-1.333 -1.333)" fill="#fff"/>
              </g>
          </svg>

      </>
  );
};


export default React.memo(SearchIcon);
